export default __webpack_public_path__ + "static/media/Setting_2.9fc98b05.svg";